const menuItems = [
	{
		icon: "mdi-home",
		title: "Início",
		route: "/home",
		testId: "menu-home",
	},
	{
		icon: "mdi-file-sign",
		title: "Páginas Institucionais",
		route: "/pages",
		testId: "menu-pages",
	},
	{
		icon: "mdi-image-area",
		title: "Banners",
		route: "/banners",
		testId: "menu-banners",
	},
	{
		icon: "mdi-ticket-percent-outline",
		title: "Cupons",
		route: "/coupons",
		testId: "menu-coupons",
	},
	{
		icon: "mdi-cellphone-message",
		title: "Notificações",
		route: "/push-notifications",
		testId: "menu-push-notifications",
	},
	{
		icon: "mdi-message-text-outline",
		title: "Frases Motivacionais",
		route: "/motivational-phrases",
		testId: "menu-motivational-phrases",
	},
	{
		icon: "mdi-comment-quote-outline",
		title: "Depoimentos",
		route: "/testimonials",
		testId: "menu-testimonials",
	},
	{
		icon: "mdi-frequently-asked-questions",
		title: "F.A.Q.",
		route: "/faq",
		testId: "menu-faq",
	},
	{
		icon: "mdi-file-document",
		title: "Planos",
		route: "/plans",
		testId: "menu-plans",
	},
	{
		icon: "mdi-handshake-outline",
		title: "Parceiros",
		route: "/partners",
		testId: "menu-partners",
	},
	{
		icon: "mdi-sale-outline",
		title: "Gerenciar Vendedores",
		route: "/saller-users",
		testId: "menu-sallers-users",
	},
	{
		icon: "mdi-cash-multiple",
		title: "Gerenciar Resgates",
		route: "/request-payments",
		testId: "menu-request-payments",
	},
	{
		icon: "mdi-account",
		title: "Usuários SAC",
		route: "/sac",
		testId: "menu-users-sac",
	},
	{
		icon: "mdi-domain-plus",
		title: "Gerenciar Empresas",
		route: "/companies",
		testId: "menu-empresarials-plans",
	},
	{
		icon: "mdi-account-group",
		title: "Gerenciar Usuários",
		route: "/users",
		testId: "menu-users",
	},
	{
		icon: "mdi-domain",
		title: "Cadastro Empresarial",
		route: "/business-registration",
		testId: "menu-business-registration",
	},
	{
		icon: "mdi-account-star",
		title: "Cadastro Individual",
		route: "/individual-registration",
		testId: "menu-individual-registration",
	},
];

export default menuItems;
